import React from "react";
import { Button, Row, Col } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";



const ConfirmVote = ({ title, fullName, loading, onOk, onCancel }) => {

    return (
        <Row gutter={24} className="p-3">
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24} className='text-center'>
                        <h4>{title}</h4>
                        <h3 className="font-weight-bold">{fullName}</h3>
                        <h4>votoi?</h4>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-4">
                    <Col xl={4} lg={2} md={2} sm={0} xs={0} />
                    <Col xl={8} lg={10} md={10} sm={12} xs={12} className="text-right">
                        <Button block type="primary" size="large" icon={<CheckOutlined />} onClick={onOk} loading={loading}>
                            Konfirmo
                        </Button>
                    </Col>
                    <Col xl={8} lg={10} md={10} sm={12} xs={12} className="text-left">
                        <Button block danger size="large" ghost icon={<CloseOutlined />} onClick={onCancel} disabled={loading}>
                            Mbyll
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default ConfirmVote;